import { defineMessages } from 'react-intl';

export default defineMessages({
  shipments: {
    defaultMessage: 'Shipments',
    id: '65ij9f',
    description: '"Shipments" label',
  },
  shippingRevenue: {
    defaultMessage: 'Shipping Revenue',
    id: 'nBFX2J',
    description: '"Shipping Revenue" label',
  },
  shippingCost: {
    defaultMessage: 'Shipping Cost',
    id: 'yoieff',
    description: '"Shipping Cost" label',
  },
  shippingNetRevenue: {
    defaultMessage: 'Net Shipping Revenue',
    id: 'f5WJXr',
    description: '"Net Shipping Revenue" label',
  },
  averageCostPerLabel: {
    defaultMessage: 'Avg Cost per Label',
    id: '/BMYTu',
    description: '"Average Cost per Label" label where Average is abbreviated',
  },
  shipmentOverviewReportTitle: {
    defaultMessage: 'Shipment Overview',
    id: 'qh5iN8',
    description: 'title for the shipment overview report',
  },
});
